import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  Menu,
  MenuItem,
  Modal,
  Paper,
  Select,
  Step,
  StepLabel,
  Stepper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import {
  addBankDetails,
  addUnlistedInvestor,
  getUnlistedInvestors,
} from "../../redux/rm/rmSlice";
import toast from "react-hot-toast";
import { formatDate } from "../../utils";
import {
  Add,
  AccountBalance,
  Check,
  CheckCircle,
  Close,
  DeleteOutline,
  DocumentScanner,
  FileDownload,
  MoreVert,
  Search,
} from "@mui/icons-material";
import { FaEdit } from "react-icons/fa";
import { getRMUser } from "../../redux/user/userSlice";
import * as XLSX from "xlsx";
import {
  softDeleteUnlistedInvestor,
  unlistedInvestorPanVerify,
  updateUnlistedInvestor,
} from "../../redux/admin/adminSlice";
import authService from "../../redux/auth/authService";
import AppLoader from "../../components/AppLoader/AppLoader";
import DocumentModal from "../../components/Modal/Unlisted/DocumentModal";
import rmService from "../../redux/rm/rmService";
import { canAccessSuperAdminFeatures } from "../../constants/adminAccess";

const steps = ["PAN", "BANK", "DP Details"];

const UnlistedInvestors = () => {
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [panQuery, setPanQuery] = useState<string>("");
  const [filterStartDate, setFilterStartDate] = useState<string>("");
  const [filterEndDate, setFilterEndDate] = useState<string>("");
  const dispatch = useDispatch<any>();
  const [pageSize, setPageSize] = useState<number>(10);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [filteredUsers, setFilteredUsers] = useState<any[]>([]);
  const [rms, setRms] = useState<any[]>([]);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [open, setOpen] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [editRm2RowId, setEditRm2RowId] = useState<number | null>(null);
  const [editRm2Value, setEditRm2Value] = useState<any>("");

  const handleUpdateInlineRm2 = async (user: any) => {
    try {
      const res = await dispatch(
        updateUnlistedInvestor({
          investorId: user.id,
          name: user.name,
          email: user.email,
          phone: user.phone,
          address: user.address,
          dob: user.dob,
          pan: user.pan,
          kycStatus: user.kycStatus,
          rmId: user.rmId,
          rmId2: editRm2Value === "" ? 0 : editRm2Value,
        })
      );

      if (res?.error?.message) {
        toast.error(res?.payload?.message);
        return;
      }
      toast.success("RM 2 updated successfully");
      setEditRm2RowId(null);
      fetchUnlistedInvestors();
    } catch (e) {
      console.error(e);
    }
  };
  const [isPanVerified, setIsPanVerified] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isSubmittingRef = useRef(false);
  const [step, setStep] = useState(1);
  const [docs, setDocs] = useState<any>({
    cmlDoc: null,
    panDoc: null,
    cancelledChequeDoc: null,
    cmlDoc2: null,
  });
  const [documentModalOpen, setDocumentModalOpen] = useState(false);
  const [documentUrls, setDocumentUrls] = useState<any>();
  const [userData, setUserData] = useState<any>();
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedUser, setSelectedUser] = useState<any>(null);
  const [bankModalOpen, setBankModalOpen] = useState(false);
  const [dematModalOpen, setDematModalOpen] = useState(false);
  const [dematDetails, setDematDetails] = useState({
    dpId2: "",
    clientId2: "",
    dpName2: "",
    cmlDoc2: null as File | null,
  });
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [deletingInvestor, setDeletingInvestor] = useState(false);
  const [bankDetails, setBankDetails] = useState({
    bankAccNo: "",
    ifscCode: "",
    bankName: "",
  });
  const [formData, setFormData] = useState<any>({
    id: "",
    name: "",
    email: "",
    alternateEmail: "",
    phone: "",
    address: "",
    pan: "",
    kycStatus: "",
    rmId: "",
    rmId2: "",
    bankAccNo: "",
    ifscCode: "",
    bankName: "",
    dpId: "",
    clientId: "",
    dpName: "",
    dpId2: "",
    clientId2: "",
    dpName2: "",
  });
  const [rmId, setRmId] = useState<any>(0);

  // Client-side filters applied on top of server-paginated results
  const displayedUsers = filteredUsers.filter((user) => {
    if (panQuery && !(user.pan || "").toLowerCase().includes(panQuery.toLowerCase())) return false;
    if (filterStartDate && new Date(user.createdAt) < new Date(filterStartDate)) return false;
    if (filterEndDate) {
      const end = new Date(filterEndDate);
      end.setHours(23, 59, 59, 999);
      if (new Date(user.createdAt) > end) return false;
    }
    return true;
  });
 
  const userType = Number(localStorage.getItem("userType") || "0");
  const canDeleteUnlistedInvestor = canAccessSuperAdminFeatures(
    authService.getAumUserId()
  );

  useEffect(() => {
    fetchRms();
    // eslint-disable-next-line 
  }, []);

  useEffect(() => {
    fetchUnlistedInvestors();
    // eslint-disable-next-line
  }, [currentPage, pageSize, searchQuery, rmId]);

  useEffect(() => {
    checkBankIFSC(formData.ifscCode);
    // eslint-disable-next-line 
  }, [formData.ifscCode]);

  useEffect(() => {
    getDpById(formData.dpId);
    // eslint-disable-next-line
  }, [formData.dpId]);

  useEffect(() => {
    checkBankIFSC(bankDetails.ifscCode);
    // eslint-disable-next-line
  }, [bankDetails.ifscCode]);

  const handleNext = async () => {
    // if (step === 2) {
    //   const result = await handleBankVerify();
    //   if (!result) return;
    // }
    if (step < 3) setStep(step + 1);
  };

  const handleBack = () => {
    if (step > 1) setStep(step - 1);
  };

  const resetState = () => {
    setFormData({
      id: "",
      name: "",
      email: "",
      alternateEmail: "",
      phone: "",
      address: "",
      pan: "",
      kycStatus: "",
      rmId: "",
      rmId2: "",
      bankAccNo: "",
      ifscCode: "",
      bankName: "",
      dpId: "",
      clientId: "",
      dpName: "",
      dpId2: "",
      clientId2: "",
      dpName2: "",
    });
    setIsPanVerified(false);
    setIsEdit(false);
    setStep(1);
    setDocs({
      panDoc: null,
      cmlDoc: null,
      cancelledChequeDoc: null,
      cmlDoc2: null,
    });
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setFormData((prev: any) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAddInvestor = async () => {
    if (isSubmittingRef.current) return;
    try {
      const isSecondaryDematFilled = formData.dpId2 || formData.clientId2 || formData.dpName2 || docs.cmlDoc2;

      if (isSecondaryDematFilled) {
        if (!formData.dpId2 || !formData.clientId2 || !formData.dpName2 || !docs.cmlDoc2) {
          toast.error("Please fill all details for the secondary Demat account (DP ID 2, Client ID 2, DP Name 2, and CML Document) or leave them all empty.");
          return;
        }
      }

      isSubmittingRef.current = true;
      setIsSubmitting(true);

      const fData = new FormData();
      fData.append("name", formData.name);
      fData.append("typeOfInvestor", formData.entityType);
      fData.append("panName", formData.panName || formData.name);
      fData.append("email", formData.email);
      fData.append("phone", formData.phone);
      if (formData.dob) fData.append("dob", formData.dob);
      fData.append("address", formData.address);
      fData.append("pan", formData.pan);
      fData.append("kycStatus", formData.kycStatus);
      fData.append(
        "rmId",
        userType === 4 ? formData.rmId : localStorage.getItem("ID")
      );
      if (userType === 4 && formData.rmId2) {
        fData.append("rmId2", formData.rmId2);
      }
      fData.append("bankAccNo", formData.bankAccNo);
      fData.append("ifscCode", formData.ifscCode);
      fData.append("bankName", formData.bankName);
      fData.append("dpId", formData.dpId);
      fData.append("clientId", formData.clientId);
      fData.append("dpName", formData.dpName);
      if (formData.dpId2) {
          fData.append("dpId2", formData.dpId2);
          fData.append("clientId2", formData.clientId2);
          fData.append("dpName2", formData.dpName2);
      }

      if (docs.cmlDoc) fData.append("cmlDoc", docs.cmlDoc);
      if (docs.cmlDoc2) fData.append("cmlDoc2", docs.cmlDoc2);
      if (docs.panDoc) fData.append("panDoc", docs.panDoc);
      if (docs.cancelledChequeDoc)
        fData.append("cancelledChequeDoc", docs.cancelledChequeDoc);

      const res = await dispatch(addUnlistedInvestor(fData));

      if (res?.error?.message) {
        toast.error(res?.payload?.message);
        return;
      }
      toast.success("Investor added successfully");
      fetchUnlistedInvestors();
      handleClose();
    } catch (error) {
      console.error("Error submitting form:", error);
    } finally {
      isSubmittingRef.current = false;
      setIsSubmitting(false);
    }
  };

  const fetchRms = async () => {
    try {
      const response = await dispatch(
        getRMUser({
          userType: 2,
          pageIndex: 1,
          pageSize: 1000,
        })
      );
      const data = response.payload.data;
      setRms(data);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  const fetchUnlistedInvestors = async () => {
    try {
      const response = await dispatch(
        getUnlistedInvestors({
          pageIndex: currentPage,
          pageSize: pageSize,
          searchQuery: searchQuery,
          rmId: userType === 4 ? rmId : localStorage.getItem("ID"),
        })
      );
      if (response?.error?.message) {
        toast.error(
          response?.payload?.message || "Failed to fetch unlisted investors"
        );
        setFilteredUsers([]);
        setTotalPages(0);
        return;
      }
      const data = response?.payload?.data;
      setFilteredUsers(data?.data || []);
      setTotalPages(data?.totalPages || 0);
    } catch (error) {
      console.error("Error fetching unlisted investors:", error);
    }
  };

  const onPageChange = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setCurrentPage(newPage + 1);
  };

  const onPageSizeChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setPageSize(Number(event.target.value));
    setCurrentPage(1);
  };

  // const handleEditUser = (user: any) => {
  //   setOpen(true);
  //   setIsEdit(true);
  //   setFormData({
  //     id: user.id,
  //     name: user.name,
  //     email: user.email,
  //     phone: user.phone,
  //     address: user.address,
  //     dob: user.dob,
  //     pan: user.pan,
  //     kycStatus: user.kycStatus,
  //     rmId: user.rmId,
  //     rmId2: user.rmId2 || "",
  //     bankAccNo: user.bankAccNo,
  //     ifscCode: user.ifscCode,
  //     dpId: user.dpId,
  //     clientId: user.clientId,
  //     dpName: user.dpName,
  //     cmlDoc: user.cmlDoc,
  //     cmlDocName: user.cmlDocName,
  //   });
  //   setIsPanVerified(user.kycStatus === "Verified");
  // };

  const handleEditInvestor = async () => {
    if (isSubmittingRef.current) return;
    try {
      isSubmittingRef.current = true;
      setIsSubmitting(true);
      const res = await dispatch(
        updateUnlistedInvestor({
          investorId: formData.id,
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          address: formData.address,
          dob: formData.dob,
          pan: formData.pan,
          kycStatus: formData.kycStatus,
          rmId: formData.rmId,
          rmId2: formData.rmId2 || null,
        })
      );

      if (res?.error?.message) {
        toast.error(res?.payload?.message);
        return;
      }
      toast.success("Investor updated successfully");
      fetchUnlistedInvestors();
      handleClose();
    } catch (error) {
      console.error("Error submitting form:", error);
    } finally {
      isSubmittingRef.current = false;
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    setOpen(false);
    resetState();
  };

  function formatDateString(dateString: string): string {
    const [year, month, day] = dateString.split("-");
    return `${day}/${month}/${year}`;
  }

  const handlePanVerify = async () => {
    try {
      setLoading(true);
      const isPropOrTrust =
        formData.entityType === "Proprietor" || formData.entityType === "Trust";
      if (isPropOrTrust && !formData.nameAsPerPan) {
        toast.error("Please enter Name as per PAN");
        setLoading(false);
        return;
      }
      const payload = {
        pancardNumber: formData.pan,
        dateOfBirth: formatDateString(formData.dob),
        fullName: formData.name,
        typeOfInvestor: formData.entityType,
        panName: formData.nameAsPerPan || formData.name,
      };
      const response = await dispatch(unlistedInvestorPanVerify(payload));
      if (response?.error?.message) {
        setLoading(false);
        toast.error(response?.payload?.message);
        return;
      }
      toast.success("Pan verified successfully");
      setLoading(false);
      setIsPanVerified(true);
      setFormData((prev: any) => ({
        ...prev,
        kycStatus: "Verified",
      }));
    } catch (error) {
      setLoading(false);
      console.error("Error submitting form:", error);
      toast.error("Pan verification failed");
    }
  };

  // const handleBankVerify = async () => {
  //   try {
  //     setLoading(true);
  //     const response = await dispatch(
  //       unlistedInvestorBankVerify({
  //         accountNumber: formData.bankAccNo,
  //         ifscCode: formData.ifscCode,
  //         fullName: formData.name,
  //       })
  //     );
  //     if (response?.error?.message) {
  //       setLoading(false);
  //       toast.error(response?.payload?.message);
  //       return false;
  //     }
  //     toast.success("Bank verified successfully");
  //     setLoading(false);
  //     setIsPanVerified(true);
  //     setFormData((prev: any) => ({
  //       ...prev,
  //       kycStatus: "Verified",
  //     }));
  //     return true;
  //   } catch (error) {
  //     setLoading(false);
  //     console.error("Error submitting form:", error);
  //     toast.error("Pan verification failed");
  //     return false;
  //   }
  // };

  const isStepValid = () => {
    if (step === 1) {
      return (
        formData.name &&
        formData.email &&
        formData.phone &&
        formData.address &&
        formData.pan &&
        isPanVerified &&
        (userType !== 4 || formData.rmId)
      );
    }

    if (step === 2) {
      return formData.bankAccNo && formData.ifscCode && formData.bankName;
    }

    if (step === 3) {
      // if (userType === 4) {
      //   return (
      //     formData.dpId &&
      //     formData.clientId &&
      //     formData.dpName &&
      //     docs.cmlDoc
      //     // docs.panDoc &&
      //     // docs.cancelledChequeDoc
      //   );
      // }
      return (
        formData.dpId && formData.clientId && formData.dpName && docs.cmlDoc
      );
    }

    return false;
  };

  const getDpById = async (dpId: string) => {
    if (!dpId || formData.dpId.length < 8) return;
    try {
      const response = await rmService.getDpById({ dpId });
      if (response?.statusCode !== 200) {
        setFormData((prev: any) => ({ ...prev, dpName: "" }));
        return;
      }
      const data = response?.data;
      setFormData((prev: any) => ({ ...prev, dpName: data?.dpName }));
    } catch (error) {
      console.error("Error fetching dp data:", error);
    }
  };

  const checkBankIFSC = (ifscCode: any) => {
    if (ifscCode && ifscCode.length === 11) {
      setLoading(true);
      fetch(`https://ifsc.razorpay.com/${ifscCode}`)
        .then((response) => response.json())
        .then((data: any) => {
          if (data.BANK) {
            if (bankModalOpen) {
              setBankDetails((prev) => ({ ...prev, bankName: data.BANK }));
            } else {
              setFormData((prev: any) => ({
                ...prev,
                bankName: data.BANK,
              }));
            }
          } else {
            toast.error("No data found for this IFSC Code");
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const handleDocChange = (e: any) => {
    const { name, files } = e.target;
    setDocs({ ...docs, [name]: files[0] });
  };

  const handleDocuments = (user: any) => {
    setDocumentUrls({
      cmlDoc: user.cmlDoc,
      panDoc: user.panDoc,
      cancelledChequeDoc: user.cancelledChequeDoc,
      cmlDoc2: user.cmlDoc2,
    });
    setUserData(user);
    setDocumentModalOpen(true);
  };

  const handleDocumentModalClose = () => {
    setDocumentModalOpen(false);
    setDocumentUrls(null);
  };

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>, user: any) => {
    setMenuAnchorEl(event.currentTarget);
    setSelectedUser(user);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };

  const handleDocumentsFromMenu = () => {
    if (selectedUser) {
      handleDocuments(selectedUser);
    }
    handleMenuClose();
  };

  const handleAddBankAccount = () => {
    if (selectedUser) {
      if (bankModalOpen) {
        setBankDetails({ bankAccNo: "", ifscCode: "", bankName: "" });
      }
      if (dematModalOpen) {
        setDematDetails({ dpId2: "", clientId2: "", dpName2: "", cmlDoc2: null });
      }
      setBankModalOpen(true);
    }
    handleMenuClose();
  };

  const handleDeleteFromMenu = () => {
    if (!selectedUser || !canDeleteUnlistedInvestor) return;
    handleMenuClose();
    setDeleteConfirmOpen(true);
  };

  const handleDeleteConfirmClose = () => {
    if (deletingInvestor) return;
    setDeleteConfirmOpen(false);
    setSelectedUser(null);
  };

  const handleDeleteConfirm = async () => {
    if (!selectedUser || !canDeleteUnlistedInvestor) return;

    try {
      setDeletingInvestor(true);
      const res = await dispatch(
        softDeleteUnlistedInvestor({ investorId: selectedUser.id })
      );
      if (res?.error) {
        toast.error(
          res?.payload?.message ||
            "You are not allowed to delete unlisted investors."
        );
        return;
      }
      toast.success("Investor removed successfully");
      setDeleteConfirmOpen(false);
      setSelectedUser(null);
      fetchUnlistedInvestors();
    } catch (e) {
      console.error(e);
      toast.error("Failed to remove investor");
    } finally {
      setDeletingInvestor(false);
    }
  };

  const handleBankModalClose = () => {
    setBankModalOpen(false);
  };

  const handleBankDetailsChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setBankDetails((prev) => ({ ...prev, [name]: value }));
  };

  const handleBankSubmit = async () => {
    if (
      !bankDetails.bankAccNo ||
      !bankDetails.ifscCode ||
      !bankDetails.bankName
    ) {
      toast.error("Please fill all bank details");
      return;
    }
    // TODO: dispatch action or API call to save bank details
    const res = await dispatch(
      addBankDetails({
        bankAccNo: bankDetails.bankAccNo,
        ifscCode: bankDetails.ifscCode,
        bankName: bankDetails.bankName,
        userId: selectedUser?.userId || selectedUser?.id,
      })
    );
    if (res?.error?.message) {
      toast.error(res?.payload?.message);
      return;
    }
    toast.success("Bank details submitted successfully!");
    setBankModalOpen(false);
  };

  const handleAddDematAccount = () => {
    if (selectedUser) {
      setDematDetails({
        dpId2: selectedUser.dpId2 || "",
        clientId2: selectedUser.clientId2 || "",
        dpName2: selectedUser.dpName2 || "",
        cmlDoc2: null,
      });
      setDematModalOpen(true);
    }
    handleMenuClose();
  };

  const handleDematModalClose = () => {
    setDematDetails({ dpId2: "", clientId2: "", dpName2: "", cmlDoc2: null });
    setDematModalOpen(false);
  };

  const handleDematSubmit = async () => {
    if (!selectedUser?.id) return;

    // "All or nothing" validation
    const hasAnyField = dematDetails.dpId2 || dematDetails.clientId2 || dematDetails.dpName2 || dematDetails.cmlDoc2;
    if (hasAnyField) {
      if (!dematDetails.dpId2 || !dematDetails.clientId2 || !dematDetails.dpName2) {
        toast.error("Please provide DP ID 2, Client ID 2, and DP Name 2 together.");
        return;
      }
      
      // If adding a Demat account for the first time, CML Document 2 is strictly required
      if (!selectedUser?.cmlDoc2 && !dematDetails.cmlDoc2) {
        toast.error("Please upload the CML Document 2.");
        return;
      }
    }

    try {
      const payload = new FormData();
      payload.append("investorId", selectedUser.id.toString());
      payload.append("dpId2", dematDetails.dpId2 || "");
      payload.append("clientId2", dematDetails.clientId2 || "");
      payload.append("dpName2", dematDetails.dpName2 || "");
      
      if (dematDetails.cmlDoc2) {
        payload.append("cmlDoc2", dematDetails.cmlDoc2);
      } else if (!hasAnyField) {
        // If the user cleared all text fields to remove the demat account, also clear the document
        payload.append("cmlDoc2", "");
      }

      const response = await dispatch(updateUnlistedInvestor(payload));
      if (response?.payload?.statusCode === 200) {
        toast.success("Secondary Demat Account updated successfully");
        fetchUnlistedInvestors();
        handleDematModalClose();
      } else {
        toast.error(response?.payload?.message || "Failed to update Demat Account");
      }
    } catch (error) {
      console.error("Error updating demat details:", error);
      toast.error("An error occurred");
    }
  };

  const exportToExcel = async () => {
    try {
      setLoading(true);

      const exportPageSize = 1000;
      const resolvedRmId = userType === 4 ? rmId : localStorage.getItem("ID");
      let pageIndex = 1;
      let totalPagesForExport = 1;
      const allUsers: any[] = [];

      while (pageIndex <= totalPagesForExport) {
        const response = await dispatch(
          getUnlistedInvestors({
            pageIndex,
            pageSize: exportPageSize,
            searchQuery: searchQuery,
            rmId: resolvedRmId,
          })
        );

        if (response?.error?.message) {
          toast.error(
            response?.payload?.message || "Failed to fetch unlisted investors"
          );
          return;
        }

        const data = response?.payload?.data;
        allUsers.push(...(data?.data || []));
        totalPagesForExport = Math.max(1, Number(data?.totalPages) || 1);
        pageIndex += 1;
      }

      // Date range is applied only on frontend; no range = export all fetched rows
      const usersToExport = allUsers.filter((user: any) => {
        if (panQuery && !(user.pan || "").toLowerCase().includes(panQuery.toLowerCase())) {
          return false;
        }
        if (filterStartDate && new Date(user.createdAt) < new Date(filterStartDate)) {
          return false;
        }
        if (filterEndDate) {
          const end = new Date(filterEndDate);
          end.setHours(23, 59, 59, 999);
          if (new Date(user.createdAt) > end) return false;
        }
        return true;
      });

      if (!usersToExport.length) {
        toast.error("No investors found for the selected filters");
        return;
      }

      const exportData = usersToExport.map((user: any) => ({
        "Unique ID": user.id || "-",
        "Client Name": user.name,
        ...(userType === 4
          ? { "RM 1 Name": user.rmName || "-", "RM 2 Name": user.rmName2 || "-" }
          : {}),
        PAN: user.pan || "-",
        Address: user.address || "-",
        "Bank Name": user.bankName || "-",
        "Bank Account Number": user.bankAccNo || "-",
        "IFSC Code": user.ifscCode || "-",
        "DP ID": user.dpId || "-",
        "DP Name": user.dpName || "-",
        "Client ID": user.clientId || "-",
        "DP ID 2": user.dpId2 || "-",
        "DP Name 2": user.dpName2 || "-",
        "Client ID 2": user.clientId2 || "-",
        Email: user.email || "-",
        Phone: user.phone || "-",
        "Date of Birth": user.dob ? formatDate(user.dob) : "-",
        "KYC Status": user.kycStatus || "-",
        "Registered At": formatDate(user.createdAt),
      }));

      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(exportData);
      XLSX.utils.book_append_sheet(workbook, worksheet, "Unlisted Investors");

      const currentDate = new Date().toISOString().split("T")[0];
      XLSX.writeFile(workbook, `Unlisted_Investors_${currentDate}.xlsx`);
      toast.success(`Exported ${usersToExport.length} investors`);
    } catch (error) {
      console.error("Error exporting unlisted investors:", error);
      toast.error("Failed to export investors");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <AppLoader loading={loading} />
      <div
        className="min-h-screen bg-lightBg py-8 px-4 sm:px-6 lg:px-8"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <Box
          width="90%"
          mb={2}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h5" style={{ textAlign: "left" }}>
            Investor Details
          </Typography>
          <Box sx={{ display: "flex", gap: 2 }}>
            <Button
              variant="outlined"
              color="primary"
              startIcon={<FileDownload />}
              onClick={exportToExcel}
              sx={{
                textTransform: "none",
                borderRadius: "8px",
                px: 3,
                py: 1,
              }}
            >
              Export Data
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => setOpen(true)}
            >
              Add Investor
            </Button>
          </Box>
        </Box>

        {/* Filters and Sorting */}
        <Box
          width="90%"
          mb={2}
          sx={{
            display: "flex",
            gap: "10px",
            flexWrap: "wrap",
            alignItems: "center",
          }}
        >
          <TextField
            variant="outlined"
            placeholder="Search by Investor Name"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
            }}
            sx={{ flex: 1, maxWidth: "250px" }}
          />

          <TextField
            variant="outlined"
            placeholder="Search by PAN"
            value={panQuery}
            onChange={(e) => setPanQuery(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
            }}
            sx={{ flex: 1, maxWidth: "200px" }}
          />

          {/* RM Filter */}
          {userType === 4 && (
            <FormControl sx={{ minWidth: "200px" }}>
              <InputLabel id="rm-label">RM</InputLabel>
              <Select
                labelId="rm-label"
                value={rmId}
                onChange={(e) => setRmId(Number(e.target.value))}
                displayEmpty
                label="RM"
              >
                <MenuItem value={0}>All RMs</MenuItem>
                {rms.map((rm: any) => (
                  <MenuItem key={rm.id} value={rm.id}>
                    {rm.firstName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}

          {/* Date Range Filter */}
          <TextField
            type="date"
            value={filterStartDate}
            onChange={(e) => setFilterStartDate(e.target.value)}
            label="From Date"
            InputLabelProps={{ shrink: true }}
            variant="outlined"
            sx={{ maxWidth: 180 }}
          />
          <TextField
            type="date"
            value={filterEndDate}
            onChange={(e) => setFilterEndDate(e.target.value)}
            label="To Date"
            InputLabelProps={{ shrink: true }}
            variant="outlined"
            sx={{ maxWidth: 180 }}
          />

          <Button variant="outlined" size="small" onClick={() => { setSearchQuery(""); setPanQuery(""); setFilterStartDate(""); setFilterEndDate(""); setRmId(0); }}>
            Clear
          </Button>
        </Box>
        <div
          style={{ display: "flex", justifyContent: "center", width: "90%" }}
        >
          <TableContainer
            component={Paper}
            style={{ width: "100%", marginTop: "1rem" }}
          >
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell style={{ fontWeight: "bold", minWidth: 80 }}>
                    Unique ID
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold", minWidth: 80 }}>
                    Client Name
                  </TableCell>
                  {userType === 4 && (
                    <>
                      <TableCell style={{ fontWeight: "bold", minWidth: 100 }}>
                        RM 1 Name
                      </TableCell>
                      <TableCell style={{ fontWeight: "bold", minWidth: 100 }}>
                        RM 2 Name
                      </TableCell>
                    </>
                  )}
                  <TableCell style={{ fontWeight: "bold", minWidth: 100 }}>
                    Pan
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold", minWidth: 130 }}>
                    Email ID
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold", minWidth: 100 }}>
                    Pnone No.
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold", minWidth: 120 }}>
                    Address
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold", minWidth: 100 }}>
                    Bank Name
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold", minWidth: 110 }}>
                    Bank Acc No.
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold", minWidth: 110 }}>
                    IFSC Code
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold", minWidth: 110 }}>
                    DP ID
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold", minWidth: 110 }}>
                    DP Name
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold", minWidth: 110 }}>
                    Client ID
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold", minWidth: 110 }}>
                    DP ID 2
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold", minWidth: 110 }}>
                    DP Name 2
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold", minWidth: 110 }}>
                    Client ID 2
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold", minWidth: 110 }}>
                    KYC Status
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold", minWidth: 130 }}>
                    Registered At
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold", minWidth: 80 }}>
                    Actions
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {displayedUsers?.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={5} style={{ textAlign: "center" }}>
                      <Typography variant="body2" color="textSecondary">
                        No users assigned
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  displayedUsers.map((user) => (
                    <TableRow key={user.id}>
                      <TableCell>{user?.id ? user?.id : "-"}</TableCell>
                      <TableCell>
                        <Button
                          style={{
                            textAlign: "left",
                            wordBreak: "break-word",
                            whiteSpace: "normal",
                          }}
                        >
                          {user.name}
                        </Button>
                      </TableCell>
                      {userType === 4 && (
                        <>
                          <TableCell
                            style={{
                              wordBreak: "break-word",
                              whiteSpace: "normal",
                            }}
                          >
                            {user?.rmName || "-"}
                          </TableCell>
                          <TableCell
                            style={{
                              wordBreak: "break-word",
                              whiteSpace: "normal",
                            }}
                          >
                            {editRm2RowId === user.id ? (
                              <Box display="flex" alignItems="center" gap={1}>
                                <Select
                                  size="small"
                                  value={editRm2Value}
                                  onChange={(e: any) => setEditRm2Value(e.target.value)}
                                  sx={{ minWidth: 120, height: 32 }}
                                >
                                  <MenuItem value=""><em>None</em></MenuItem>
                                  {rms.map((rm: any) => (
                                    <MenuItem key={rm.id} value={rm.id}>{rm.firstName}</MenuItem>
                                  ))}
                                </Select>
                                <IconButton size="small" color="primary" onClick={() => handleUpdateInlineRm2(user)}>
                                  <Check fontSize="small" />
                                </IconButton>
                                <IconButton size="small" color="error" onClick={() => setEditRm2RowId(null)}>
                                  <Close fontSize="small" />
                                </IconButton>
                              </Box>
                            ) : (
                              <Box display="flex" alignItems="center" gap={1} sx={{ minHeight: "32px" }}>
                                <Typography variant="body2">{user?.rmName2 || "-"}</Typography>
                                <IconButton 
                                  size="small" 
                                  onClick={() => { 
                                    setEditRm2RowId(user.id); 
                                    setEditRm2Value(user.rmId2 || ""); 
                                  }}
                                  sx={{ padding: "4px" }}
                                >
                                  <FaEdit size={14} color="#1976d2" />
                                </IconButton>
                              </Box>
                            )}
                          </TableCell>
                        </>
                      )}
                      <TableCell>{user?.pan ? user?.pan : "-"}</TableCell>
                      <TableCell
                        style={{
                          wordBreak: "break-word",
                          whiteSpace: "normal",
                        }}
                      >
                        {user?.email ? user?.email : "-"}
                      </TableCell>
                      <TableCell>{user?.phone ? user?.phone : "-"}</TableCell>
                      <TableCell
                        style={{
                          wordBreak: "break-word",
                          whiteSpace: "normal",
                        }}
                      >
                        {user?.address}
                      </TableCell>
                      <TableCell>{user?.bankName || "-"}</TableCell>
                      <TableCell>{user?.bankAccNo || "-"}</TableCell>
                      <TableCell>{user?.ifscCode || "-"}</TableCell>
                      <TableCell>{user?.dpId || "-"}</TableCell>
                      <TableCell>
                        {user?.dpName?.length > 15
                          ? user?.dpName?.slice(0, 15) + "..."
                          : user?.dpName || "-"}
                      </TableCell>
                      <TableCell>{user?.clientId || "-"}</TableCell>
                      <TableCell>{user?.dpId2 || "-"}</TableCell>
                      <TableCell>
                        {user?.dpName2?.length > 15
                          ? user?.dpName2?.slice(0, 15) + "..."
                          : user?.dpName2 || "-"}
                      </TableCell>
                      <TableCell>{user?.clientId2 || "-"}</TableCell>
                      <TableCell>{user?.kycStatus}</TableCell>
                      <TableCell>{formatDate(user.createdAt)}</TableCell>
                      <TableCell>
                        <IconButton
                          color="primary"
                          onClick={(event) => handleMenuOpen(event, user)}
                        >
                          <MoreVert />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TablePagination
                    rowsPerPageOptions={[10, 20, 50, 100]}
                    count={totalPages * pageSize}
                    rowsPerPage={pageSize}
                    page={currentPage - 1}
                    onPageChange={onPageChange}
                    onRowsPerPageChange={onPageSizeChange}
                    labelDisplayedRows={({ from, to, count }) =>
                      `${currentPage} – ${totalPages}`
                    }
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
        </div>

        {/* Dropdown Menu */}
        <Menu
          anchorEl={menuAnchorEl}
          open={Boolean(menuAnchorEl)}
          onClose={handleMenuClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <MenuItem onClick={handleDocumentsFromMenu}>
            <DocumentScanner sx={{ mr: 1 }} />
            Documents
          </MenuItem>
          <MenuItem onClick={handleAddBankAccount}>
            <AccountBalance sx={{ mr: 1 }} />
            Add Bank Account
          </MenuItem>

          <MenuItem onClick={handleAddDematAccount}>
            <Add sx={{ mr: 1 }} />
            Add Demat Account
          </MenuItem>

          {canDeleteUnlistedInvestor && (
            <MenuItem onClick={handleDeleteFromMenu} sx={{ color: "error.main" }}>
              <DeleteOutline sx={{ mr: 1 }} />
              Delete
            </MenuItem>
          )}
        </Menu>

        {/* Add Bank Account Modal */}
        <Modal open={bankModalOpen} onClose={handleBankModalClose}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 400,
              bgcolor: "background.paper",
              border: "2px solid #000",
              boxShadow: 24,
              p: 4,
              borderRadius: 2,
            }}
          >
            <Box display="flex" justifyContent="space-between" mb={2}>
              <Typography variant="h6" mb={2}>
                Add Bank Account
              </Typography>
              <IconButton onClick={handleBankModalClose}>
                <Close />
              </IconButton>
            </Box>
            <Box display="flex" flexDirection="column" gap={2}>
              <TextField
                label="Bank Account No"
                type="number"
                name="bankAccNo"
                value={bankDetails.bankAccNo}
                onChange={handleBankDetailsChange}
                fullWidth
              />
              <TextField
                label="IFSC Code"
                name="ifscCode"
                value={bankDetails.ifscCode}
                onChange={handleBankDetailsChange}
                fullWidth
              />
              <TextField
                label="Bank Name"
                name="bankName"
                value={bankDetails.bankName}
                onChange={handleBankDetailsChange}
                fullWidth
              />
              <Box display="flex" justifyContent="flex-end" gap={2} mt={2}>
                <Button variant="outlined" onClick={handleBankModalClose}>
                  Cancel
                </Button>
                <Button variant="contained" onClick={handleBankSubmit}>
                  Submit
                </Button>
              </Box>
            </Box>
          </Box>
        </Modal>

        {/* Add Secondary Demat Modal */}
        <Modal open={dematModalOpen} onClose={handleDematModalClose}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 400,
              bgcolor: "background.paper",
              border: "2px solid #000",
              boxShadow: 24,
              p: 4,
              borderRadius: 2,
            }}
          >
            <Box display="flex" justifyContent="space-between" mb={2}>
              <Typography variant="h6" mb={2}>
                Add Demat Account
              </Typography>
              <IconButton onClick={handleDematModalClose}>
                <Close />
              </IconButton>
            </Box>
            <Box display="flex" flexDirection="column" gap={2}>
              <TextField
                label="DP ID 2"
                name="dpId2"
                value={dematDetails.dpId2}
                onChange={(e) => setDematDetails({ ...dematDetails, dpId2: e.target.value })}
                inputProps={{ maxLength: 8 }}
                fullWidth
              />
              <TextField
                label="DP Name 2"
                name="dpName2"
                value={dematDetails.dpName2}
                onChange={(e) => setDematDetails({ ...dematDetails, dpName2: e.target.value })}
                fullWidth
              />
              <TextField
                label="Client ID 2"
                name="clientId2"
                value={dematDetails.clientId2}
                onChange={(e) => setDematDetails({ ...dematDetails, clientId2: e.target.value })}
                inputProps={{ maxLength: 8 }}
                fullWidth
              />
              <Box>
                <Typography variant="body2" mb={1}>
                  Upload CML Document 2
                </Typography>
                <input
                  type="file"
                  accept=".pdf,.jpg,.jpeg,.png"
                  onChange={(e) => {
                    if (e.target.files && e.target.files[0]) {
                      setDematDetails({ ...dematDetails, cmlDoc2: e.target.files[0] });
                    }
                  }}
                />
              </Box>
              <Box display="flex" justifyContent="flex-end" gap={2} mt={2}>
                <Button variant="outlined" onClick={handleDematModalClose}>
                  Cancel
                </Button>
                <Button variant="contained" onClick={handleDematSubmit} sx={{ bgcolor: "#2f4050", "&:hover": { bgcolor: "#233342" } }}>
                  Submit
                </Button>
              </Box>
            </Box>
          </Box>
        </Modal>

        <Modal
          open={open}
          onClose={(event, reason) => {
            if (reason === "backdropClick") return;
            handleClose();
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 800,
              maxHeight: "90vh",
              bgcolor: "background.paper",
              border: "2px solid #000",
              boxShadow: 24,
              p: 4,
              overflowY: "auto",
              borderRadius: 2,
            }}
          >
            <Box display="flex" justifyContent="space-between" mb={2}>
              <Typography variant="h6">
                {isEdit ? "Edit Investor" : "Add Investor"} — Step {step}/3
              </Typography>
              <IconButton onClick={handleClose}>
                <Close />
              </IconButton>
            </Box>

            <Box mb={4}>
              <Stepper activeStep={step - 1}>
                {steps.map((label) => (
                  <Step key={label}>
                    <StepLabel>{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
            </Box>

            <Box component="form" noValidate autoComplete="off">
              <div className="grid grid-cols-2 gap-4">
                {/* Step 1: Basic Info */}
                {step === 1 && (
                  <>
                    <TextField
                      label="Name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      fullWidth
                      required
                    />
                    <FormControl fullWidth required>
                      <InputLabel id="entity-type-label">
                        Type Of Investor
                      </InputLabel>
                      <Select
                        labelId="entity-type-label"
                        label="Entity Type"
                        value={formData.entityType}
                        onChange={(e) =>
                          setFormData((prev: any) => ({
                            ...prev,
                            entityType: e.target.value,
                            nameAsPerPan:
                              e.target.value === "Proprietor" ||
                              e.target.value === "Trust"
                                ? prev.nameAsPerPan
                                : "",
                          }))
                        }
                      >
                        <MenuItem value="Individual">Individual</MenuItem>
                        <MenuItem value="Corporate">Corporate</MenuItem>
                        <MenuItem value="Proprietor">Proprietor</MenuItem>
                        <MenuItem value="Trust">Trust</MenuItem>
                        <MenuItem value="Others">Others</MenuItem>
                      </Select>
                    </FormControl>
                    <TextField
                      label="Name as per PAN"
                      name="nameAsPerPan"
                      value={formData.nameAsPerPan}
                      onChange={handleChange}
                      fullWidth
                      required={
                        formData.entityType === "Proprietor" ||
                        formData.entityType === "Trust"
                      }
                      disabled={
                        !(
                          formData.entityType === "Proprietor" ||
                          formData.entityType === "Trust"
                        )
                      }
                      sx={{
                        "& .MuiOutlinedInput-root.Mui-disabled": {
                          backgroundColor: "#E0E0E0",
                          borderRadius: 1,
                        },

                        "& .MuiOutlinedInput-root.Mui-disabled fieldset": {
                          borderColor: "#9E9E9E",
                        },

                        "& .MuiInputBase-input.Mui-disabled": {
                          WebkitTextFillColor: "#424242",
                          cursor: "not-allowed",
                        },

                        "& .MuiInputLabel-root.Mui-disabled": {
                          color: "#616161",
                        },
                      }}
                    />
                    <TextField
                      label="Phone"
                      name="phone"
                      type="tel"
                      value={formData.phone}
                      onChange={handleChange}
                      fullWidth
                      required
                    />
                    <TextField
                      label="Email"
                      name="email"
                      type="email"
                      value={formData.email}
                      onChange={handleChange}
                      fullWidth
                      required
                    />
                    <TextField
                      label="Alternate Email (as per CML)"
                      name="alternateEmail"
                      type="email"
                      value={formData.alternateEmail}
                      onChange={handleChange}
                      fullWidth
                      // required
                    />
                    <TextField
                      label="Date of Birth"
                      name="dob"
                      type="date"
                      value={formData.dob}
                      onChange={handleChange}
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      inputProps={{
                        min: "1900-01-01",
                        max: new Date().toISOString().split("T")[0],
                      }}
                    />
                    <TextField
                      label="PAN"
                      name="pan"
                      value={formData.pan}
                      onChange={(e) => {
                        setFormData((prev: any) => ({
                          ...prev,
                          pan: e.target.value.toUpperCase(),
                        }));
                      }}
                      disabled={!formData.dob || !formData.name}
                      fullWidth
                      required
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            {isPanVerified ? (
                              <CheckCircle sx={{ color: "green" }} />
                            ) : (
                              <Button
                                variant="text"
                                onClick={handlePanVerify}
                                sx={{
                                  textTransform: "none",
                                  fontSize: "0.75rem",
                                }}
                              >
                                Verify
                              </Button>
                            )}
                          </InputAdornment>
                        ),
                      }}
                    />
                    <div className="space-y-3">
                      <TextField
                        label="Address"
                        name="address"
                        value={formData.address}
                        onChange={handleChange}
                        fullWidth
                        multiline
                        rows={4}
                        required
                      />
                    </div>
                    {userType === 4 && (
                      <>
                        <FormControl fullWidth required variant="outlined" style={{ marginBottom: 15 }}>
                          <InputLabel id="rm-label">Select RM</InputLabel>
                          <Select
                            labelId="rm-label"
                            onChange={(e) =>
                              setFormData((prev: any) => ({
                                ...prev,
                                rmId: e.target.value,
                              }))
                            }
                            label="Select RM"
                            value={formData?.rmId || ""}
                          >
                            {rms.map((rm) => (
                              <MenuItem key={rm.id} value={rm.id}>
                                {rm.firstName}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        <FormControl fullWidth variant="outlined">
                          <InputLabel id="rm2-label">Select RM 2 (Optional)</InputLabel>
                          <Select
                            labelId="rm2-label"
                            onChange={(e) =>
                              setFormData((prev: any) => ({
                                ...prev,
                                rmId2: e.target.value,
                              }))
                            }
                            label="Select RM 2 (Optional)"
                            value={formData?.rmId2 || ""}
                          >
                            <MenuItem value=""><em>None</em></MenuItem>
                            {rms.map((rm) => (
                              <MenuItem key={`rm2-${rm.id}`} value={rm.id}>
                                {rm.firstName}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </>
                    )}
                  </>
                )}

                {/* Step 2: Bank Details */}
                {step === 2 && (
                  <>
                    <TextField
                      label="Bank Account No"
                      name="bankAccNo"
                      value={formData.bankAccNo}
                      onChange={handleChange}
                      fullWidth
                      required
                    />
                    <TextField
                      label="IFSC Code"
                      name="ifscCode"
                      value={formData.ifscCode}
                      onChange={handleChange}
                      fullWidth
                      required
                    />
                    <TextField
                      label="Bank Name"
                      name="bankName"
                      value={formData.bankName}
                      onChange={handleChange}
                      fullWidth
                      required
                      InputLabelProps={{ shrink: true }}
                    />
                    <TextField
                      label="Full Name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      fullWidth
                      required
                    />
                  </>
                )}

                {/* Step 3: DP Details */}
                {step === 3 && (
                  <>
                    <Box sx={{ gridColumn: "span 2" }}>
                      <Typography variant="subtitle1" fontWeight="bold">Primary Demat Account</Typography>
                    </Box>
                    <TextField
                      label="DP ID"
                      name="dpId"
                      value={formData.dpId}
                      onChange={handleChange}
                      fullWidth
                      required
                    />
                    <TextField
                      label="Client ID"
                      name="clientId"
                      value={formData.clientId}
                      onChange={handleChange}
                      fullWidth
                      required
                    />
                    <TextField
                      label="DP Name"
                      name="dpName"
                      value={formData.dpName}
                      onChange={handleChange}
                      fullWidth
                      required
                    />
                    <TextField
                      type="file"
                      name="cmlDoc"
                      onChange={handleDocChange}
                      fullWidth
                      helperText="Upload CML Document *"
                      InputLabelProps={{ shrink: true }}
                      required
                    />
                    <TextField
                      type="file"
                      name="panDoc"
                      onChange={handleDocChange}
                      fullWidth
                      helperText="Upload PAN Card"
                      InputLabelProps={{ shrink: true }}
                    />
                    <TextField
                      type="file"
                      name="cancelledChequeDoc"
                      onChange={handleDocChange}
                      fullWidth
                      helperText="Upload Cancelled Cheque"
                      InputLabelProps={{ shrink: true }}
                    />

                    <Box sx={{ gridColumn: "span 2", mt: 2 }}>
                      <Typography variant="subtitle1" fontWeight="bold">Secondary Demat Account (Optional)</Typography>
                      <Typography variant="body2" color="textSecondary">If you fill any of these, you must provide all four.</Typography>
                    </Box>
                    <TextField
                      label="DP ID 2"
                      name="dpId2"
                      value={formData.dpId2}
                      onChange={handleChange}
                      fullWidth
                    />
                    <TextField
                      label="Client ID 2"
                      name="clientId2"
                      value={formData.clientId2}
                      onChange={handleChange}
                      fullWidth
                    />
                    <TextField
                      label="DP Name 2"
                      name="dpName2"
                      value={formData.dpName2}
                      onChange={handleChange}
                      fullWidth
                    />
                    <TextField
                      type="file"
                      name="cmlDoc2"
                      onChange={handleDocChange}
                      fullWidth
                      helperText="Upload CML Document 2"
                      InputLabelProps={{ shrink: true }}
                    />
                  </>
                )}
              </div>

              {/* Navigation Buttons */}
              <Box display="flex" justifyContent="space-between" mt={4}>
                <Button onClick={handleBack} disabled={step === 1}>
                  Back
                </Button>

                {step < 3 ? (
                  <Button
                    onClick={handleNext}
                    variant="contained"
                    disabled={!isStepValid()}
                  >
                    Next
                  </Button>
                ) : (
                  <Button
                    onClick={() =>
                      isEdit ? handleEditInvestor() : handleAddInvestor()
                    }
                    variant="contained"
                    className="bg-blue-600 text-white"
                    disabled={!isStepValid() || isSubmitting}
                  >
                    {isSubmitting ? "Submitting..." : "Submit"}
                  </Button>
                )}
              </Box>
            </Box>
          </Box>
        </Modal>
        <Dialog
          open={deleteConfirmOpen}
          onClose={handleDeleteConfirmClose}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle sx={{ fontWeight: 700 }}>Remove investor</DialogTitle>
          <DialogContent dividers>
            <Typography>
              Remove <strong>{selectedUser?.name || "this investor"}</strong>?
              They will be hidden from lists and reports. This action cannot be
              undone from the portal.
            </Typography>
          </DialogContent>
          <DialogActions sx={{ p: 2, gap: 1 }}>
            <Button
              onClick={handleDeleteConfirmClose}
              disabled={deletingInvestor}
              variant="outlined"
              color="inherit"
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={handleDeleteConfirm}
              disabled={deletingInvestor}
              startIcon={
                deletingInvestor ? (
                  <CircularProgress size={16} color="inherit" />
                ) : undefined
              }
            >
              {deletingInvestor ? "Removing..." : "Remove"}
            </Button>
          </DialogActions>
        </Dialog>

        {/*  Document download modal */}
        <DocumentModal
          open={documentModalOpen}
          handleClose={handleDocumentModalClose}
          documentUrls={documentUrls}
          userData={userData}
          fetchUnlistedInvestors={fetchUnlistedInvestors}
        />
      </div>
    </>
  );
};

export default UnlistedInvestors;
